






















import { Component, Mixins } from "vue-property-decorator";

import LessonScore from "@/components/ReportResultTable/Score.vue";

import { IProgressReportItem } from "@/models/interfaces/report-generator";
import ReportsMixin from "./Reports.mixin";

@Component({
  components: {
    LessonScore
  }
})
export default class LessonReport extends Mixins<
  ReportsMixin<IProgressReportItem[]>
>(ReportsMixin) {
  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: "First name"
      },
      {
        value: "lastname",
        label: "Last name"
      },
      {
        value: "username",
        label: "Username"
      },
      {
        label: "Start Line score",
        custom: true,
        name: "baselineScore"
      },
      {
        label: "Checkpoint score",
        custom: true,
        name: "assessmentScore"
      },
      {
        label: "Progress",
        custom: true,
        name: "progress"
      }
    ];
  }

  public getScore(score: number, placeholder?: string) {
    const isTaken = typeof score === "number";

    return isTaken ? `${score}%` : placeholder ?? "Not taken";
  }

  public generateCsvFile() {
    const headers = {
      firstname: "First name",
      lastname: "Last name",
      username: "Username",
      baselineScore: "Start Line score",
      assessmentScore: "Checkpoint score",
      progress: "Progress"
    };

    const data =
      this.reportData.map(item => ({
        firstname: item.firstname,
        lastname: item.lastname,
        username: item.username,
        baselineScore: this.getScore(item.baselineScorePC),
        assessment: this.getScore(item.assessmentScorePC),
        progress: this.getScore(item.progressPC)
      })) || [];

    this.exportCSVFile(headers, data, this.title);
  }
}
